module.exports = __webpack_public_path__ + "img/howGet.a3041132.png";